import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Cascader, Select, DatePicker, Radio, Checkbox, Button, Icon, Tooltip } from 'antd';
import Text from '../../../basicElement/Text';
import { getMatchOption, generateOptions } from '../../../shared/selectFn';
import deepClone from '../../../shared/deepClone';
import format from '../../../shared/format';

const width = 240;
const paddingLeft = 19.891;
const longWidth = 700 + paddingLeft;
const { Option } = Select;
const Default = {
    0: '否',
    1: '是'
};

const defaultOption = generateOptions(Default, 'radio');

const formatToCascaderOption = (data) => {
    (data || []).forEach(item => {
        item.value = item.complaintConfigureId;
        item.label = item.optionValue;
        
        if (item.childList && item.childList.length > 0) {
            item.children = item.childList;
            formatToCascaderOption(item.children);
        }
    });
};

function addSuffixMoney (text){
    return text ? `${format('money', text)}元` : '';
}

function UpdateView(props, context) {
    const { data, editable, onChange, viewCloumeDetail } = props;
    const { configure } = context;
    const { REMITTANCE_POSSIBILITY = [], KEY_BLOCKING_TYPE = [] } = configure || {};
    const { csaList = [], mainPmList=[] } = data || {};
    const handleChange = (value, key) => {
        switch (key) {
            case 'complaintFrom':
                data[key] = value;
                data.complaintFromRemark = undefined;
                break;
            case 'complaintPosition':
                data[key] = value;
                data.complaintPositionRemark = undefined;
                break;
            case 'complaintedUser': {
                const { value: id, text: name, leaderName, leaderCode } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                data.leaderName = leaderName;
                data.leaderCode = leaderCode;
                break;
            }
            case 'investigation': {
                const { value: id, text: name } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                data.investigation = value;
                data.investigationSiteId = '';
                data.investigationSiteName = '';
                break;
            }
            case 'investigationSite': {
                const { value: id, text: name } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                break;
            }
            case 'complaintMainResponsible': {
                const otherId = MAIN_RESPONSIBLE.filter(i => i.optionValue == '其他')[0].complaintConfigureId;
                if (
                    (value.includes(otherId) && !(data.complaintMainResponsible || []).includes(otherId)) ||
                    (!value.includes(otherId) && (data.complaintMainResponsible || []).includes(otherId))
                ) {
                    data.complaintMainResponsibleRemark = undefined;
                }
                data[key] = value;
                break;
            }
            case 'keyBlockingId' :{
                const operationType = KEY_BLOCKING_TYPE.filter(i => i.coTraceConfigureId == value)[0].operationType;
                data.operationType = operationType;
                if(operationType == 'pm')
                {
                    if(mainPmList && mainPmList.length)
                    {
                        const { userCompellation, employeeCode } = mainPmList[0];
                        data.pmNameCode =  `${userCompellation}[${employeeCode}]`;
                    }
                }
                data[key] = value;
                break;
            }
            default: {
                data[key] = value;
                break;
            }
        }
        onChange(data);
    };
    const remittancePossibilityOption = REMITTANCE_POSSIBILITY.map(i => <Option key={i.coTraceConfigureId}>{i.typeValue}</Option>);
    const keyBlockingOption = KEY_BLOCKING_TYPE.map(i => <Option key={i.coTraceConfigureId}>{i.typeValue}</Option>);
    const csaListOption = csaList.map(i => <Option key={i.userId}>{`${i.userCompellation}[${i.employeeCode}]`}</Option>);
    return (
        <div style={{ background: '#fafafa' }}>
            <div className="historyContractRecordUpdate" style={{paddingBottom:10}}>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text colon={true}>项目简称</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                               data.investigationName
                            }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>JDE主项目号</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.jdeMainCode }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>项目类型</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.investigationGlobalTypeShow }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>业务线</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.lineOfBusinessString }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>执行业务线二级分类</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.secondLineNames }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>项目分期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.byStageNames }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>项目分类</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.invTypeName }
                        </Col>
                    </Col>
                   
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>计收入确认方式</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.contractTypeValue }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>PM</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.pmNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>项目领域</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.investigationAreaName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>疾病</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.diseaseName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>领域leader</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.areaLeaderNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>PML（包含大区总监）</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.pmlNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>BD</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.bdNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>CSA</Text>
                        </Col>
                        <Col span={15} offset={1}>
                           { data.csaNameCode }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>合同额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.contractAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>最终应回款合同额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.finalReturnAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>请款规则</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <a onClick={()=> viewCloumeDetail({...data, modalTitle: '请款规则'}, 'rule')}>查看详情</a>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>累计已开票金额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.totalInvoiceAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>累计回款金额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.totalReturnAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>
                                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计回款金额/最终应回款金额'}>
                                    <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                                </Tooltip>&nbsp;
                                累计回款比例
                            </Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.totalReturnPercent }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>
                                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计收入不含税/服务费不含税'}>
                                    <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                                </Tooltip>&nbsp;
                                已确认收入比例
                            </Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.confirmIncomePercent }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>
                                累计请款开票比例
                            </Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.totalInvoicePercent }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>当前可请款节点</Text>
                        </Col>
                        <Col span={15} offset={1}>
                        <a onClick={()=> viewCloumeDetail({...data, modalTitle: '当前可请款节点'}, 'node')}>查看详情</a>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>当月预计应开票金额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.thisMonthPredictInvoiceAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>当月已开票金额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.thisMonthInvoiceAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>下一笔请款预计日期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { data.nextRemittanceDate }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>下一笔请款金额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.nextRemittanceAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                            <Col span={8}>
                                <Text asterisk={editable} colon={true}>下月开票可能性判断</Text>
                            </Col>
                            <Col span={14} offset={1}>
                              <Select
                                allowClear={true}
                                placeholder="请选择"
                                 style={{width}}
                                value={format('toString', data.nextInvoicePossibilityId)}
                                onChange={value => handleChange(value, 'nextInvoicePossibilityId')}
                                >
                                 {remittancePossibilityOption}
                              </Select>
                            </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>下月预计开票金额/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(data.nextMonthPredictInvoiceAmount) }
                        </Col>
                    </Col>
                    <Col span={24}>
                            <Col span={4}>
                                <Text asterisk={editable} colon={true}>PM填写更新请款进度</Text>
                            </Col>
                            <Col span={20} style={{ paddingLeft }}>
                                <Input
                                    placeholder="请输入"
                                    style={{ width: longWidth - 10 }}
                                    value={data.remittanceProcess}
                                    onChange={e => handleChange(e.target.value, 'remittanceProcess')}
                                />
                            </Col>
                    </Col>
                    <Col span={12}>
                            <Col span={8}>
                                <Text colon={true}>更新请款进度</Text>
                            </Col>
                            <Col span={14} offset={1}>
                             <a onClick={()=> viewCloumeDetail({...data, modalTitle: '更新请款进度'}, 'baprocess')}>查看详情</a>
                            </Col>
                    </Col>
                    <Col span={12}>
                            <Col span={8}>
                                <Text asterisk={editable} colon={true}>当前卡脖子节点负责人</Text>
                            </Col>
                            <Col span={14} offset={1}>
                                 <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{width}}
                                    value={format('toString', data.keyBlockingId)}
                                    onChange={value => handleChange(value, 'keyBlockingId')}
                                    >
                                    {keyBlockingOption}
                                </Select>
                            </Col>
                    </Col>
                    {
                        data.operationType == 'pm' && <Col span={12}>
                         <Col span={8}>
                             <Text asterisk={editable} colon={true}>津石PM</Text>
                         </Col>
                         <Col span={14} offset={1}>
                             {data.pmNameCode}
                         </Col>
                        </Col>
                    }
                    {
                        data.operationType == 'ba' && <Col span={12}>
                         <Col span={8}>
                             <Text colon={true}>负责人CSA</Text>
                         </Col>
                         <Col span={14} offset={1}>
                              <Select
                                mode="multiple"
                                 allowClear={true}
                                 placeholder="请选择"
                                 style={{width}}
                                 value={data.baUserIds}
                                 onChange={value => handleChange(value, 'baUserIds')}
                                 >
                                 {csaListOption}
                             </Select>
                         </Col>
                        </Col>
                    }
                </Row>
            </div>
        </div>
    );
}

UpdateView.contextTypes = {
    configure: PropTypes.object
};

export default UpdateView;


// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/FundsUpdateView.js